import {IUser} from "../../../../../app/interfaces/user/IUser";
import {IChatSocketCommand} from "../../../../../app/types/ChatSocketCommand";

export const readMessagesCommand = (currentUser: IUser, toUser: string): IChatSocketCommand => ({
    cmd: 'read',
    userId: currentUser.uniqueUserValue ?? currentUser.idStr ?? '',
    toUserId: toUser
});